import React from 'react';
import useStyles from './selectFieldStyles';

import MenuItem   from '@mui/material/MenuItem';
import TextField  from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';

//TODO może kiedyś dodać jakieś filtry/walidację jak będzie potrzebne, zobaczymy jak filtry zostaną oficjalnie dodane


function SelectField({ value, setValue, label, options, includeEmptyOption, ...props }) {

  const { classes } = useStyles();

  const menu = React.useMemo(
    () => generateSelectOptions(options, includeEmptyOption, classes),
    [options, includeEmptyOption, classes]
  );

  return (
    <TextField
      select
      fullWidth
      {...props}
      value={value || ''}
      onChange={(evt) => setValue(evt.target.value)}
      label={label}
    >
      {menu}
    </TextField>
  );
}

SelectField.propTypes = {
  ...TextField.propTypes,
  value:    PropTypes.string,
  setValue: PropTypes.func.isRequired,
  label:    PropTypes.string.isRequired,
  options:  PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ])),
    PropTypes.arrayOf(PropTypes.object),
  ]).isRequired,
  includeEmptyOption: PropTypes.bool
};

export function createSelectOption(value, label) {
  label = label == null ? value : label;
  return {
    value: value,
    label: label,
  };
}

/**
 * @param options {(String | Object)[] | Object} - array of strings or objects {value, label} or object with structure {value: label}
 * @param includeEmptyOption {Boolean=} - allows user to select empty option
 * @param classes {Object=} - object of classNames to style options
 */
export function generateSelectOptions(options, includeEmptyOption, classes) {
  classes = classes || {};
  const result = [];

  if (includeEmptyOption) {
    const emptyOption = createSelectOption('');
    result.push(createMenuItem(
      emptyOption, -1, classes.emptyOption
    ));
  }

  if (!options || options.length === 0) {
    return result;
  }
  if (typeof options !== 'object') {
    console.warn('Options in select are not object or array?', options);
  }

  if (Array.isArray(options)) {
    options.forEach((option, index) => {
      if (typeof option === 'string') { //Array of strings
        const preparedOption = createSelectOption(option);
        result.push(createMenuItem(
          preparedOption, index, classes.option
        ));
      } else { //Array of objects
        result.push(createMenuItem(
          option, index, classes.option
        ));
      }
    });
  } else {
    for (const key in options) {
      const preparedOption = createSelectOption(key, options[key]);
      result.push(createMenuItem(
        preparedOption, key, classes.option
      ));
    }
  }
  return result;
}

export function createMenuItem(option, index, className) {
  const label = option.label == null ? option.value : option.label;
  const key = index == null ? option.value : index;

  return (
    <MenuItem
      key={key}
      value={option.value}
      className={className}
    >
      <Typography variant='inherit' noWrap>
        {label}
      </Typography>
    </MenuItem>
  );
}

export default React.memo(SelectField);
